import React from 'react'
import { Stack, csx } from '@vtex/admin-ui'
import { BuyNowButton } from '@/checkout-instore-legacy/components/Commons/BuyNowButton'
import { BuyButtonContainerProps } from '@/checkout-instore-legacy/components/Commons/BuyComponent/BuyButtonContainer'
import { AddToCartButton } from '@/checkout-instore-legacy/components/Commons/AddToCartButton'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

const commonButtonsCss = csx({ width: '100%' })

export type ProductPageBuyActionsProps = BuyButtonContainerProps

export const ProductPageBuyActions = ({
  ...props
}: ProductPageBuyActionsProps) => {
  const { showPdpAddToCartButton } = getInstoreConfig()

  return (
    <Stack space="$space-3" className={csx({ marginY: '$space-6' })}>
      <BuyNowButton className={commonButtonsCss} {...props} />
      {showPdpAddToCartButton && (
        <AddToCartButton className={commonButtonsCss} {...props} />
      )}
    </Stack>
  )
}
